import { http } from '@/api/http';
import { ApiResponseBody, Uuid } from '@/api/types';
import { getOfferApiUrl } from '../offer.paths';
import {
  AttachDonorSummaryRequest,
  DonorSummaryParseResponse,
  DonorSummaryResponse,
  DonorSummaryUploadUrlRequest,
  DonorSummaryUploadUrlResponse,
} from './donor-summary.types';

const getDonorSummaryUploadUrl = async (
  offerId: Uuid,
  body: DonorSummaryUploadUrlRequest,
): Promise<DonorSummaryUploadUrlResponse> => {
  const res = await http.post<ApiResponseBody<DonorSummaryUploadUrlResponse>>(
    getOfferApiUrl.donorSummaryUploadUrl(offerId),
    body,
  );
  return res.data.data;
};

const attachDonorSummary = async (offerId: Uuid, body: AttachDonorSummaryRequest): Promise<DonorSummaryResponse> => {
  const res = await http.put<ApiResponseBody<DonorSummaryResponse>>(getOfferApiUrl.donorSummary(offerId), body);
  return res.data.data;
};

const getDonorSummary = async (offerId: Uuid): Promise<DonorSummaryResponse | null> => {
  const res = await http.get<ApiResponseBody<DonorSummaryResponse | null>>(getOfferApiUrl.donorSummary(offerId));
  return res.data.data;
};

const deleteDonorSummary = async (offerId: Uuid): Promise<void> => {
  await http.delete<ApiResponseBody<void>>(getOfferApiUrl.donorSummary(offerId));
};

const startDonorSummaryParse = async (offerId: Uuid): Promise<Uuid | null> => {
  const res = await http.post<ApiResponseBody<Uuid | null>>(getOfferApiUrl.donorSummaryParse(offerId));
  return res.data.data;
};

const getLatestDonorSummaryParse = async (offerId: Uuid): Promise<DonorSummaryParseResponse | null> => {
  const res = await http.get<ApiResponseBody<DonorSummaryParseResponse | null>>(
    getOfferApiUrl.donorSummaryParse(offerId),
  );
  return res.data.data;
};

const getDonorSummaryParseById = async (offerId: Uuid, parseId: Uuid): Promise<DonorSummaryParseResponse> => {
  const res = await http.get<ApiResponseBody<DonorSummaryParseResponse>>(
    getOfferApiUrl.donorSummaryParseById(offerId, parseId),
  );
  return res.data.data;
};

export const donorSummaryFetcher = {
  getDonorSummaryUploadUrl,
  attachDonorSummary,
  getDonorSummary,
  deleteDonorSummary,
  startDonorSummaryParse,
  getLatestDonorSummaryParse,
  getDonorSummaryParseById,
};
